const GET_SUBSCRIPTIONS = `
  query Subscriptions {
    account {
      subscriptions {
        resourceId
        friendlyId
        type
        createdAt
        devices {
          items {
            identity {
              friendlyName
              makeAndModel {
                name
              }
            }
          }
        }
        state
        billing {
          nextBillingCycle {
            chargeDate
          }
        }
        addOns {
          priceCents
          type
        }
        entities {
          ... on InstantInkEntity {
            resourceId
            type
            product {
              description
            }
          }
          ... on InstantPaperEntity {
            resourceId
            type
          }
          ... on DeviceEntity {
            resourceId
            type
            product {
              sku
              type
              name
              image
            }
          }
        }
      }
    }
  }
`;

export default GET_SUBSCRIPTIONS;
